import React, { useEffect, useState } from 'react';
import './App.css';
import XbrlConverter from './components/XbrlConverter';
import LoginForm from './components/LoginForm';
import api from './services/api';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('auth/status/')
      .then(res => {
        if (res.data?.authenticated) {
          setUser(res.data.user);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleLogout = async () => {
    try {
      await api.get('auth/csrf/');
      await new Promise(r => setTimeout(r, 100));
      await api.post('auth/logout/');
    } catch (e) {
      // ignore
    }
    setUser(null);
  };

  if (loading) {
    return (
      <div className="App">
        <header className="App-header">
          <img src="/VMR_Logo.png" alt="View My Records" className="site-logo" />
          <h1 className="app-title">HTML to XBRL Converter</h1>
        </header>
        <main>
          <div style={{ textAlign: 'center', padding: '60px 20px', color: '#666', fontSize: '1.1rem' }}>
            Loading...
          </div>
        </main>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="App">
        <header className="App-header">
          <img src="/VMR_Logo.png" alt="View My Records" className="site-logo" />
          <h1 className="app-title">HTML to XBRL Converter</h1>
        </header>
        <main>
          <LoginForm onLogin={setUser} />
        </main>
      </div>
    );
  }

  return (
    <div className="App">
      <header className="App-header">
        <img src="/VMR_Logo.png" alt="View My Records" className="site-logo" />
        <h1 className="app-title">HTML to XBRL Converter</h1>
        <div className="user-bar">
          <span className="user-email">{user.name || user.email}</span>
          <button type="button" className="logout-btn" onClick={handleLogout}>Sign out</button>
        </div>
      </header>
      <main>
        <XbrlConverter user={user} />
      </main>
    </div>
  );
}

export default App;
